import { render } from "./PracticeAddons.vue?vue&type=template&id=3025e2f2"
import script from "./PracticeAddons.vue?vue&type=script&lang=js"
export * from "./PracticeAddons.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__